import { render, staticRenderFns } from "./TxPrice.vue?vue&type=template&id=5ee3aee4&scoped=true&"
import script from "./TxPrice.vue?vue&type=script&lang=js&"
export * from "./TxPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee3aee4",
  null
  
)

export default component.exports